export default {
    get_siteInfo:state => state.app.siteInfo,
    get_AgentSite:state => state.app.isAgentSite,
    get_language:state => state.app.language,
    get_languageCode:state => state.app.languageCode,
    get_languageList:state => state.app.languageList,
    get_currencyActive:state => state.app.currencyActive,
    get_currencyList:state => state.app.currencyList,
    get_isMobile:state => state.app.isMobile,
    get_ShowCaptcha:state => state.app.ShowCaptcha,
    get_CaptchaVerifiedID:state => state.app.CaptchaVerifiedID,
  }



// WEBPACK FOOTER //
// ./src/store/getter.js